export default __webpack_public_path__ + "ff6296ab379fd87ae3de4317e0054985.svg";